/*
 * � 2020 Microsoft. All rights reserved.
 */

define ('Arkadium/GameEngine/Scenes/Nodes/SceneNode',['pixi'], function (PIXI) {

});
